import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/ui/ResponsiveStyles.css';
import App from './App';
import { removeServiceWorker } from './serviceWorkerRegistration';
import errorTracker from './services/errorTracker';
import { applyThemeVars } from './theme/cssVars';

// Inject the generated design-token CSS variables (:root + [data-theme="dark"])
// before first paint so themed surfaces never flash unstyled values.
applyThemeVars();

// Install client error tracking before React renders
errorTracker.install();
window.addEventListener('beforeunload', () => errorTracker.flush());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// The CRM ships no service worker. Every load, in every environment, removes
// any registration still present and empties Cache Storage.
removeServiceWorker();
